import { render, staticRenderFns } from "./DetalhesNotificacaoPush.vue?vue&type=template&id=3da848e0&scoped=true&"
import script from "./DetalhesNotificacaoPush.vue?vue&type=script&lang=js&"
export * from "./DetalhesNotificacaoPush.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesNotificacaoPush.vue?vue&type=style&index=0&id=3da848e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da848e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCol,VIcon,VProgressCircular,VRow,VSimpleTable})
